import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../authentication/authHelpers";
import { getCurrentDuty } from "../components/Aquaman/api/aquamanApi";

// Shared by the employee widget, the once-a-week popup and the admin list
// widget. One request feeds all three: the caller's own current week (`isMe`
// tells the popup whether to fire) plus the upcoming assignees per branch.
const useAquamanDuty = ({ upcoming = 8, enabled = true } = {}) => {
  const { employeeId } = useAuth();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDuty = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const res = await getCurrentDuty({ employeeId, upcoming });
      setData(res);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [employeeId, upcoming, enabled]);

  useEffect(() => {
    fetchDuty();
  }, [fetchDuty]);

  return {
    loading,
    error,
    refresh: fetchDuty,
    current: data?.current || null,
    roster: data?.roster || null,
    upcoming: data?.upcoming || [],
    rosters: data?.rosters || [],
    isMyDuty: !!data?.isMe,
  };
};

export default useAquamanDuty;
